/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'./internal/ConfirmationComponent',
	'react-dom',
	'react'
], function ($, View, ConfirmationComponent, ReactDOM, React) {
	'use strict';

	class ConfirmationDialog extends View {

		init(...args){
			super.init(...args);
			const properties = args[0] || {};
			this.className = properties.className;
			this.size = properties.size;
			this.title = properties.title;
			this.message = properties.message;
			this.viewClass = properties.viewClass;
			this.viewOptions = properties.viewOptions;
			this.confirmCallback = properties.confirmCallback;
			this.cancelCallback = properties.cancelCallback;
			this.className = properties.className;
			this.primaryButtonText = properties.primaryButtonText;
			this.secondaryButtonText = properties.secondaryButtonText;
			this.reactDomNode = this.$el[0];
		}

		render() {
			ReactDOM.render(
				<ConfirmationComponent
					title={this.title}
					message={this.message}
					size={this.size}
					onOK={this.onOK.bind(this)}
					onCancel={this.onCancel.bind(this)}
					className={this.className}
					primaryButtonText={this.primaryButtonText}
					secondaryButtonText={this.secondaryButtonText}
				/>,
				this.reactDomNode
			);
			if(this.viewClass) {
				this.view = new this.viewClass(this.viewOptions);
				this.view.render();
				$('.dashboardConfirmationDialog .dialogBody').append(this.view.$el);
			}
		}

		remove() {
			if(this.reactDomNode) {
				ReactDOM.unmountComponentAtNode(this.reactDomNode);
			}
			if(this.view) {
				this.view.remove();
			}
			if(this.$el) {
				this.$el.remove();
			}
			this.$el = null;
			ConfirmationDialog.inherited('remove', this);
		}

		onOK() {
			this.remove();
			if (this.confirmCallback){
				this.confirmCallback();
			}
		}

		onCancel() {
			this.remove();
			if (this.cancelCallback){
				this.cancelCallback();
			}
		}
	}

	return ConfirmationDialog;
});
